import { Box, useTheme } from '@material-ui/core';

export const ChatMessageReaction = ({
  emoji,
  count,
  onPress,
  style,
  selected,
}: {
  emoji: string;
  count?: number;
  onPress: (emoji: string) => void;
  style?: React.CSSProperties;
  selected?: boolean;
}) => {
  const theme = useTheme();

  return (
    <Box
      onClick={() => onPress(emoji)}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
        backgroundColor: selected ? theme.palette.background.default : theme.palette.background.paper,
        outline: selected ? `2px solid ${theme.palette.divider}` : `1px solid ${theme.palette.divider}`,
        padding: '2px 12px',
        paddingTop: 4,
        borderRadius: 16,
        cursor: 'pointer',
        fontSize: 16,
        ...style,
      }}
    >
      {emoji}
      {count && count > 1 && (
        <Box style={{ fontSize: 15, color: theme.palette.text.secondary }}>{count}</Box>
      )}
    </Box>
  );
};
